'use client';

import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  text-align: center;
`;

export const title = css`
  font-size: 1.5rem;
  font-weight: 700;
  color: ${theme.colors.primary[1]};
`;

export const subtitle = css`
  max-width: 700px;
  align-self: center;
`;

export const images = css`
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
  gap: 1rem;
  > * {
    width: 100%;
    max-width: 45%;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    align-items: center;
    font-size: 1rem;
    font-weight: 600;
    color: ${theme.colors.neutral[4]};
    img {
      width: 90px;
    }
    @media screen and (width > ${theme.sizes.screens.md}) {
      max-width: calc(20% - 1rem);
    }
  }
`;
